/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../index';

/**
 * The schema for updating an existing CredentialSchema.
 */
export interface CredentialSchemaUpdate {
    schema: Truvity.ClaimsSchemaOptional;
}
